import { render, staticRenderFns } from "./MAUest.vue?vue&type=template&id=203b6f29&scoped=true"
import script from "./MAUest.vue?vue&type=script&lang=ts"
export * from "./MAUest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b6f29",
  null
  
)

export default component.exports